/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_1_ProjectInputs */

const en_landing_pricing_feature_1_project = /** @type {(inputs: Landing_Pricing_Feature_1_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 project`)
};

const zh_landing_pricing_feature_1_project = /** @type {(inputs: Landing_Pricing_Feature_1_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 个项目`)
};

/**
* | output |
* | --- |
* | "1 project" |
*
* @param {Landing_Pricing_Feature_1_ProjectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_1_project = /** @type {((inputs?: Landing_Pricing_Feature_1_ProjectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_1_ProjectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_1_project(inputs)
	return zh_landing_pricing_feature_1_project(inputs)
});
export { landing_pricing_feature_1_project as "landing.pricing.feature_1_project" }